import * as React from "react";
import { Sparkle } from "lucide-react";
import { Separator } from "@/components/ui/separator";
export default function DecorativeDivider() {
  return;
}